import { render } from "./Background.vue?vue&type=template&id=0898ba3c"
const script = {}

import "./Background.vue?vue&type=style&index=0&id=0898ba3c&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__